'use strict';

var base = require('base/search/search');

// Redirect to another category lvl 3
$(document).on('change', '.categories-list', function () {
    var catSelected = $('option:selected', this).attr("data-url");
    if (catSelected) {
        window.location = catSelected;
    }
});

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    if (!$updates.length) {
        return;
    }
    var html = $updates.first().html();
    var $targets = $(selector);
    if (!$targets.length) {
        return;
    }
    $targets.empty().html(html);
}

/**
* Get specific parameters from a URL.
*
* @param {string} url - The URL to extract parameters from.
* @param {Array} params - The list of parameter names to extract.
* @return {Object} The extracted parameters as key-value pairs.
*/
function getSpecificParams (url, params) {
    const urlObj = new URL(url);
    const result = {};

    params.forEach(param => {
        if (urlObj.searchParams.has(param)) {
            result[param] = urlObj.searchParams.get(param);
        }
    });

    return result;
}

/**
 * Parse Search-ShowAjax HTML for DOM queries (multi-root safe).
 * @param {string|*} response - Ajax response body
 * @returns {JQuery} Wrapper containing parsed nodes
 */
function parseAjaxResponse(response) {
    if (typeof response !== 'string') {
        return $('<div>').append(response);
    }
    var $wrapper = $('<div>');
    var $parsed = $(response);
    if ($parsed.length) {
        $wrapper.append($parsed);
    } else {
        $wrapper.append($.parseHTML(response, document, false));
    }
    return $wrapper;
}

/**
 * Whether PLP wishlist heart marking is disabled (Kohler storefront).
 * @returns {boolean} True when wishlist marking should be skipped
 */
function isWishlistMarkingSkipped() {
    return $('#search-form').data('sucursal') === 'kohler';
}

/**
 * Apply favorite heart state to wishlist icons within a scope.
 * @param {Object.<string, boolean>} itemsId - map of product IDs in the wishlist
 * @param {JQuery} [$scope] - optional container; defaults to the PLP product grid
 * @returns {undefined}
 */
function markWishlistHearts(itemsId, $scope) {
    var $tiles = ($scope && $scope.length)
        ? $scope.find('.wishlistTile')
        : $('.product-grid.sp-grid .wishlistTile');

    $tiles.each(function () {
        var $icon = $(this).find('i').first();
        var pid = $(this).closest('.product').data('pid');
        if (!pid || !$icon.length) {
            return;
        }
        if (itemsId[pid]) {
            $icon.removeClass('heart-white').addClass('in-wishlist');
        } else {
            $icon.removeClass('in-wishlist').addClass('heart-white');
        }
    });
}

/**
 * Fetch wishlist product IDs and invoke callback with the items map.
 * @param {function(Object.<string, boolean>)} callback - receives the wishlist items map
 * @returns {undefined}
 */
function loadWishlistItems(callback) {
    var url = $('#wishlist-get-json-list').val();
    if (!url) {
        callback({});
        return;
    }
    $.ajax({
        url: url,
        method: 'GET',
        success: function (response) {
            window.itemsInFavorites = response.itemsId || {};
            callback(window.itemsInFavorites);
        },
        error: function () {
            callback(window.itemsInFavorites || {});
        }
    });
}

/**
 * Re-mark PLP wishlist hearts after Ajax grid updates (Search-UpdateGrid / Search-ShowAjax).
 * @param {JQuery} [$scope] - optional container for newly inserted tiles
 * @returns {undefined}
 */
function refreshWishlistHearts($scope) {
    if (isWishlistMarkingSkipped()) {
        return;
    }
    loadWishlistItems(function (itemsId) {
        markWishlistHearts(itemsId, $scope);
    });
}

/**
 * Reload Einstein PLP carousel after grid refresh (slot scripts do not run on .html() insert).
 * @returns {undefined}
 */
function relaunchPlpEinsteinRecommendations() {
    if ($('.plp-einstein-recommender .plp-ec').length) {
        $(document).trigger('launchPlpRecommendations');
    }
}

/**
 * Update product grid from Ajax without dropping the recommendations block when absent from the fragment.
 * @param {JQuery} $results - parsed Ajax response
 * @returns {undefined}
 */
function updateProductGridFromResults($results) {
    var $source = $results.find('.search-results .product-grid.sp-grid').first();
    if (!$source.length) {
        $source = $results.find('.product-grid.sp-grid').first();
    }
    if (!$source.length) {
        $source = $results.find('.product-grid').first();
    }
    var isUpdateGridFragment = false;
    if (!$source.length && ($results.find('.grid-footer').length || $results.find('.sp-grid-productTile').length)) {
        isUpdateGridFragment = true;
    }
    var $target = $('.search-results .product-grid.sp-grid').first();
    if (!$target.length) {
        $target = $('.product-grid.sp-grid').first();
    }
    if ((!$source.length && !isUpdateGridFragment) || !$target.length) {
        return;
    }

    var $detachedEinstein = $target.find('.plp-einstein-recommender').closest('.col-12');
    if ($detachedEinstein.length) {
        $detachedEinstein = $detachedEinstein.detach();
    }

    var sourceHtml = isUpdateGridFragment ? $results.html() : $source.html();
    $target.empty().html(sourceHtml);

    if (!$target.find('.plp-einstein-recommender').length && $detachedEinstein.length) {
        $target.append($detachedEinstein);
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = parseAjaxResponse(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.show-more',
        '.filter-bar',
        '.sp-order-categorylist [name="sort-order"]',
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    updateProductGridFromResults($results);

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    relaunchPlpEinsteinRecommendations();
    refreshWishlistHearts($('.product-grid.sp-grid'));
}

/**
 * Parse Search-UpdateGrid response (sort order) and preserve the Einstein carousel.
 * @param {string} response - Ajax response HTML
 * @param {string} selectedUrl - sort option URL used for the request
 * @returns {undefined}
 */
function parseSortResults(response, selectedUrl) {
    var $results = parseAjaxResponse(response);
    updateProductGridFromResults($results);
    relaunchPlpEinsteinRecommendations();

    var paramsToExtract = ['srule'];
    var extractedParams = getSpecificParams(selectedUrl, paramsToExtract);

    $('.refinements').find('button').each(function () {
        var href = $(this).attr('data-href');
        if (href) {
            href = href.replace(/&?srule=[^&]*/g, '');
            href = href.replace(/&?start=[^&]*/g, '');
            href = href.replace(/&?sz=[^&]*/g, '');
            $(this).attr('data-href', href + '&' + $.param(extractedParams));
        }
    });
}

/**
 * Resolve collapse panel from `data-target` (e.g. "#color"). Using DOM id avoids jQuery/Sizzle errors when value is "#" alone or not a valid selector.
 * @param {string} targetSel - attribute data-target
 * @returns {JQuery} Panel element wrapped in jQuery, or empty if invalid / missing
 */
function getCollapsePanelFromDataTarget(targetSel) {
    if (!targetSel || typeof targetSel !== 'string') {
        return $();
    }
    var trimmed = targetSel.trim();
    if (!trimmed || trimmed === '#') {
        return $();
    }
    if (trimmed.charAt(0) !== '#') {
        return $();
    }
    var id = trimmed.slice(1);
    if (!id) {
        return $();
    }
    var el = document.getElementById(id);
    return el ? $(el) : $();
}

/**
 * Snapshot Bootstrap collapse open/closed state per refinement accordion (data-target → expanded).
 * @returns {Object.<string, boolean>} Map of data-target selector to whether the panel was expanded.
 */
function captureAccordionFilterStates() {
    var states = {};
    $('.refinement-bar .btn-accordion-filter').each(function () {
        var $btn = $(this);
        var targetSel = $btn.attr('data-target');
        if (!targetSel) {
            return;
        }
        var $panel = getCollapsePanelFromDataTarget(targetSel);
        if (!$panel.length) {
            return;
        }
        states[targetSel] = $panel.hasClass('show') || !$btn.hasClass('collapsed');
    });
    return states;
}

/**
 * Reapply accordion states after Ajax refreshes .refinements. Only affects panels still present.
 * @param {Object.<string, boolean>} states - from captureAccordionFilterStates
 * @returns {undefined}
 */
function restoreAccordionFilterStates(states) {
    if (!states || typeof states !== 'object') {
        return;
    }
    $('.refinement-bar .btn-accordion-filter').each(function () {
        var targetSel = $(this).attr('data-target');
        if (!targetSel || !Object.prototype.hasOwnProperty.call(states, targetSel)) {
            return;
        }
        var isOpen = states[targetSel];
        var $btn = $(this);
        var $panel = getCollapsePanelFromDataTarget(targetSel);
        if (!$panel.length) {
            return;
        }
        $panel.removeClass('collapsing').css('height', '');
        if (isOpen) {
            $panel.addClass('show');
            $btn.attr('aria-expanded', 'true').removeClass('collapsed');
        } else {
            $panel.removeClass('show');
            $btn.attr('aria-expanded', 'false').addClass('collapsed');
        }
    });
}

/**
* Build the filter url
* @param {string} _url - The base url
* @param {Object} filters - The filters to build the url from
* @returns {string} The new url
* @param {string} skipValue - The value to skip
*/
function buildFilterUrl(_url, filters, skipValue) {
    let urlObj = new URL(_url, window.location.origin);
    let searchParams = new URLSearchParams(urlObj.search);

    let filterGroups = {};

    // Group the values by id without duplicates, skipping `skipValue`
    filters.forEach(filter => {
        if (filter.displayValue === skipValue) return;
        if (filter.id === 'RegionesList') return;

        if (!filterGroups[filter.id]) {
            filterGroups[filter.id] = new Set();
        }
        filterGroups[filter.id].add(filter.displayValue);
    });

    Array.from(searchParams.keys()).forEach(function(key) {
        if (key.startsWith("prefn") || key.startsWith("prefv")) {
            searchParams.delete(key);
        }
    });

    let index = 1;
    Object.keys(filterGroups).forEach(key => {
        let values = Array.from(filterGroups[key]);
        if (values.length > 0) { // Evitar agregar filtros vacíos
            searchParams.append(`prefn${index}`, key);
            searchParams.append(`prefv${index}`, values.join('|'));
            index++;
        }
    });

    return `${urlObj.pathname}${searchParams && searchParams.size > 0 ? '?' + searchParams.toString() : ''}`;
}

var MIN_VISIBLE_PRODUCTS_OFERTA = 6;
var MAX_AUTO_LOAD_PRODUCTS_OFERTA = 12;
var autoLoadOfertaProductsCount = 0;
var isAutoLoadMoreOfertaClick = false;

/**
 * Reset auto-load product counter (manual "show more" starts a new cycle).
 * @returns {undefined}
 */
function resetAutoLoadOfertaCounter() {
    autoLoadOfertaProductsCount = 0;
}

/**
 * Count visible product tiles in an Ajax HTML fragment (Search-UpdateGrid).
 * @param {string} response - Ajax response HTML
 * @returns {number} Number of visible product tiles
 */
function countProductsInResponse(response) {
    var $results = parseAjaxResponse(response);
    return $results.find('.sp-grid-productTile').length;
}

/**
 * Whether the current PLP is a categoria oferta (from server-rendered data attributes).
 * @returns {boolean} True when the page is a categoria oferta PLP
 */
function isOfertaCategoryPage() {
    return !!$('.site-search').data('is-category-oferta');
}

/**
 * Auto-click "show more" on oferta PLP when the last batch has fewer than 6 visible products.
 * Stops after 12 products loaded via auto-click chain; counter resets on manual "show more".
 * @param {string} [response] - Ajax response from Search-UpdateGrid; when omitted, uses initial page data attrs
 * @returns {undefined}
 */
function maybeAutoLoadMoreOferta(response) {
    if (!isOfertaCategoryPage()) {
        return;
    }

    var $showMoreButton = $('.show-more button');
    if (!$showMoreButton.length) {
        return;
    }

    if (typeof response === 'string') {
        var batchCount = countProductsInResponse(response);
        autoLoadOfertaProductsCount += batchCount;

        if (autoLoadOfertaProductsCount >= MAX_AUTO_LOAD_PRODUCTS_OFERTA) {
            return;
        }

        if (batchCount >= MIN_VISIBLE_PRODUCTS_OFERTA) {
            return;
        }
    } else {
        var countedHiddenProducts = $('.site-search').data('counted-hidden-products');
        countedHiddenProducts = countedHiddenProducts ? parseInt(countedHiddenProducts, 10) : 0;
        if (!countedHiddenProducts || countedHiddenProducts <= MIN_VISIBLE_PRODUCTS_OFERTA) {
            return;
        }
    }

    // Mark next click as automatic so showMore() does not reset the cycle counter.
    isAutoLoadMoreOfertaClick = true;
    $showMoreButton.click();
}

var refinmentBar = $('.refinement-bar');
if (refinmentBar.length > 0) {
    var categories = refinmentBar.data('by-category');
    var displayCategoryCount = 0;
    if (categories) {
        let catFilters = $('.accordion-filter-refvalue');
        for (var i = 0; i < catFilters.length; i++) {
            if (categories[catFilters[i].dataset.displayValue]) {
                $(catFilters[i]).text($(catFilters[i]).text().replace(/\(\d+\)/, '(' + categories[catFilters[i].dataset.displayValue] + ')'));
                $(catFilters[i]).removeClass('d-none');
                $(catFilters[i]).closest("li").removeClass('d-none');
                displayCategoryCount++;
            }
        }
    }
    if (displayCategoryCount === 0) {
        $('span#clasificacionProducto').addClass('d-none');
    }
}

$(document).ready(function(){
    maybeAutoLoadMoreOferta();

    $(document).on('click', '.isColorMaxView', function (e) {
        var interView = document.getElementsByClassName($(this).attr("id"));

        for (var ir = 0; ir < interView.length; ir++) {
            interView[ir].classList.remove('d-none');
        }

        e.currentTarget.classList.add('d-none');
    });
    if (window.location.href.includes('#') || window.location.href.includes('pid')) {
        var metaCre = document.createElement('meta');
        metaCre.name = "robots";
        metaCre.content = "noindex,nofollow";
        document.getElementsByTagName('head')[0].appendChild(metaCre);
    } else {
        var metaDel = document.querySelector('meta[name="robots"]');
        var isKohler = window.location.href.includes("kohlerbyinterceramic");
        if (isKohler) {
            return;
        }
        if (metaDel) {
            metaDel.parentNode.removeChild(metaDel);
        }
    }
    if (performance.getEntriesByType('navigation')[0].type === 'back_forward') {
        const sortOrderSelector = $('[name=sort-order]');
        const defaultSelected = sortOrderSelector.children().first().is(':selected');
        if (defaultSelected) { return; }
        const sortOrder = localStorage.getItem('sortOrder');
        if (sortOrder) {
            $('select[name="sort-order"]').val($('select[name="sort-order"]').find("."+sortOrder).val());
            localStorage.removeItem('sortOrder');
            sortOrderSelector.trigger('change');
        }
        if (!sortOrder && $("select[name=sort-order]").val() === null) {
            $('select[name="sort-order"]').val($('select[name="sort-order"]').find(".bestMatch").val());
        }
    } else {
        localStorage.removeItem('sortOrder');
    }
});

$(document).ready(function () {
    refreshWishlistHearts();
});

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container-fluid').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background-filter').addClass("refinement-bar-visible");
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },
    closeRefinements: function () {
        // Refinements close button
        $('.container-fluid').on('click', '.refinement-bar button.close, .modal-background', function () {
            $('.refinement-bar, .modal-background-filter').removeClass("refinement-bar-visible");
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },
    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background-filter').removeClass("refinement-bar-visible");
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },
    sort: function () {
        // Handle sort order menu selection
        $('.container-fluid').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            let classForSelectedElement = $(this).find("[value='"+this.value+"']").attr("class");
            localStorage.setItem('sortOrder', classForSelectedElement);
            const selectedUrl = this.value;
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    parseSortResults(response, selectedUrl);
                    refreshWishlistHearts($('.product-grid.sp-grid'));
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    showMore: function () {
        // Show more products
        $('.container-fluid').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            var isAutoClick = isAutoLoadMoreOfertaClick;
            isAutoLoadMoreOfertaClick = false;
            if (!isAutoClick) {
                resetAutoLoadOfertaCounter();
            }

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    var permalinkValue = $(".permalink").val();
                    if (permalinkValue) {
                        try {
                            var urlParts = permalinkValue.split('?');
                            var baseUrl = urlParts[0];
                            var params = new URLSearchParams(urlParts[1]);
                            
                            Array.from(params.keys()).forEach(function(param) {
                                if (param.includes('http')) {
                                    params.delete(param);
                                }
                            });
                            
                            var cleanUrl = baseUrl + (params.toString() ? '?' + params.toString() : '');
                            var dataFilters = JSON.parse($("#data-filter-json").val());
                            var buildUrl = buildFilterUrl(cleanUrl, dataFilters, '');
                            window.history.pushState({}, null, buildUrl);
                        } catch (error) {
                            window.history.pushState({}, null, permalinkValue);
                        }
                    }

                    maybeAutoLoadMoreOferta(response);
                    refreshWishlistHearts($('.product-grid.sp-grid'));
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container-fluid').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();

                var accordionFilterStates = captureAccordionFilterStates();

                let isKohler = window.location.href.includes("kohlerbyinterceramic");
                if (isKohler) {
                    if ($(this).data("title") == "colorGenerico") {
                        var colorGenerico = $(".swatch-filter[title='"+$(this).data("value")+"']");
                        if (colorGenerico.length > 0) {
                            colorGenerico.parent("button").trigger("click");
                            return;
                        }
                    }
                    if ($(this).data("title") == "clasificacionProducto") {
                        var clasificacionProducto = $("span[refinement-id='clasificacionProducto'][data-display-value='"+$(this).data("value")+"']");
                        if (clasificacionProducto.length > 0) {
                            clasificacionProducto.parent("button").trigger("click");
                            return;
                        }
                    }
                }
                $(this).trigger('search:filter', e);

                var searchUrl = $(this).data('href');
                var seoUrl = $(this).data('seo-href') || searchUrl;
                var isAplicableMeta = searchUrl.includes('prefn') || searchUrl.includes('prefv') ? true : false;
                window.isAplicableMeta = isAplicableMeta;
                const sortingSelected = $('[name=sort-order]').val();
                const sortingSelectorOptions =  $('[name=sort-order]').find('option');
                var sortingClassSelected = '';
                sortingSelectorOptions.each(function (index, element) {
                    if (element.value === sortingSelected) {
                        // sortingClassSelected is used to keep the selected sorting option after the ajax call
                        sortingClassSelected = element.className;
                    }
                });
                if (seoUrl) {
                    window.history.pushState({}, null, seoUrl);
                    const currentUrl = window.location.href; 
                    const [basePath, queryString] = currentUrl.split("?");
                    if (queryString) {
                        const params = new URLSearchParams(queryString);
                        params.delete("srule");
                        const updatedUrl = `${basePath}${params.toString() ? `?${params.toString()}` : ''}`;
                        if (updatedUrl !== currentUrl) {
                            window.history.replaceState(null, "", updatedUrl);
                        }
                    }
                }

                const isResetBtn = $(this).hasClass("reset");
                // Reset the sorting option to the first option when a refinement is selected
                if (isResetBtn) {
                    var sortOrderSelector = $('[name=sort-order]');
                    var firstOption = sortOrderSelector.find('option:first');
                    sortOrderSelector.val(firstOption.val());
                }

                var attributeId = '#' + $(this).find('span').last().attr('id');
                $.ajax({
                    url: searchUrl,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: searchUrl
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        if (window.isAplicableMeta) {
                            var metaCre = document.createElement('meta');
                            metaCre.name = "robots";
                            metaCre.content = "noindex,nofollow";
                            document.getElementsByTagName('head')[0].appendChild(metaCre);
                        } else {
                            var metaDel = document.querySelector('meta[name="robots"]');
                            if (metaDel) {
                                metaDel.parentNode.removeChild(metaDel);
                            }
                        }
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                        // Set the selected sorting option after the ajax call
                        let selectedSortingElement = $('[name=sort-order]').find('option.' + sortingClassSelected);
                        if (selectedSortingElement.length > 0 && !isResetBtn) {
                            $('[name=sort-order]').val(selectedSortingElement.val());
                        }
                        setTimeout(function() {
                            const url = new URL(searchUrl, window.location.origin);
                            const searchParams = url.searchParams;

                            let medidaGenerica = null;
                            var dataFilters = JSON.parse($("#data-filter-json").val());
                            
                            var pageSearchUrl = window.location.search;
                            var newUrl = buildFilterUrl(pageSearchUrl, dataFilters, '');
                            // Update the search url with the clean url
                            let cleanPath = window.location.pathname.endsWith('/') ? window.location.pathname.slice(0, -1) : window.location.pathname;
                            window.history.replaceState(null, null, window.location.origin + cleanPath + newUrl);
                            
                            const filterBar = $('.filter-bar');
                            const buttonsInFilterBar = filterBar.find('button[data-title]');
                            buttonsInFilterBar.each(function() {
                                const dataHref = $(this).data('href');
                                const skipColor = $(this).find("span").first().text();
                                const newButtonHref = buildFilterUrl(dataHref, dataFilters, skipColor);
                                $(this).attr('data-href', newButtonHref)
                                    .data('href', newButtonHref);
                            });
                            /* Update the size filter buttons */
                            var buttonsInFilters = $(".accordion-filter-content-values").find("button").find("span.selected");
                            buttonsInFilters.each(function() {
                                const dataHref = $(this).parent('button').data('href');
                                const skipValue = $(this).attr("data-display-value");
                                const newButtonHref = buildFilterUrl(dataHref, dataFilters, skipValue);
                                $(this).parent('button').attr('data-href', newButtonHref)
                                    .data('href', newButtonHref);
                            });
                            /* Update the color filter buttons */
                            var buttonsColorInFilter = $(".accordion-content-values-ul").find(".isActiveColor-Search").parent('button');
                            buttonsColorInFilter.each(function() {
                                const dataHref = $(this).data('href');
                                const skipColor = $(this).find("span.color").first().text();
                                const newButtonHref = buildFilterUrl(dataHref, dataFilters, skipColor);
                                $(this).attr('data-href', newButtonHref)
                                    .data('href', newButtonHref);
                            });
                        }, 500);
                        var byCategory = refinmentBar.data('by-category');
                        var displayCategory = 0;
                        if (byCategory) {
                            let catFilters = $('.accordion-filter-refvalue');
                            for (var j = 0; j < catFilters.length; j++) {
                                if (byCategory[catFilters[j].dataset.displayValue]) {
                                    $(catFilters[j]).text($(catFilters[j]).text().replace(/\(\d+\)/, '(' + byCategory[catFilters[j].dataset.displayValue] + ')'));
                                    $(catFilters[j]).removeClass('d-none');
                                    $(catFilters[j]).closest("li").removeClass('d-none');
                                    displayCategory++;
                                }
                            }
                        }
                        if (displayCategory === 0) {
                            $('span#clasificacionProducto').addClass('d-none');
                        }
                        restoreAccordionFilterStates(accordionFilterStates);
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    }
                });
            }
        );
    },
    showContentTab: function () {
        // Display content results from the search
        $('.container-fluid').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container-fluid').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },
    onPopState: base.onPopState()
};
